import axios from 'axios';
import qs from 'qs';

import {MessageBox} from 'element-ui';

import cookie from './cookie.js';

const queryStringFix = obj => {
  let result = [];
  Object.keys(obj).forEach(key => {
    let val = obj[key];
    if (val instanceof Array && ['string', 'number'].includes(typeof val[0])) {
      val.forEach(item => {
        result.push(`${key}[]=${encodeURIComponent(item)}`);
      });
    } else {
      result.push(`${key}=${encodeURIComponent(val)}`);
    }
  });
  return result.join('&');
};

export const AccountInfo = {
  getAccountFromSys() {
    try {
      if (location.href.indexOf('agent.html') > -1) {
        if (window.GLOBAL && window.GLOBAL.userInfo) {
          return window.GLOBAL.userInfo;
        }
        return {};
      }
      const sessionCustomerId = sessionStorage.getItem('customerId');
      if (sessionCustomerId && sessionCustomerId != 'undefined') {
        return {
          customerId: sessionCustomerId
        };
      }
      const openerSessionCustomerId = window.opener && window.opener.sessionStorage.getItem('customerId');
      if (openerSessionCustomerId && openerSessionCustomerId != 'undefined') {
        sessionStorage.setItem('customerId', openerSessionCustomerId);
        return {
          customerId: openerSessionCustomerId
        };
      }
      let hash = location.hash;
      let rs = hash.match(/index\/(\d+)\/?(\d)?/);
      let customerId = '';
      if (rs) {
        customerId = rs[2] ? rs[1] + '' + rs[2] : rs[1];
      } else {
        const temp = cookie.getItem('customerId') || cookie.getItem('subAccountId')?.replace(',', '');
        if (temp) {
          customerId = temp;
        }
        // customerId = cookie.getItem('customerId') || cookie.getItem('subAccountId')?.replace(',', '');
      }
      customerId && customerId != 'undefined' && sessionStorage.setItem('customerId', customerId);
      // const customerId = cookie.getItem('customerId') || cookie.getItem('subAccountId') || sessionStorage.getItem('customerId');
      return {
        customerId
      };
    } catch (e) {
      console.log(e);
      return {
        customerId: ''
      }
    }
  }
};

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

axios.interceptors.request.use(function (config) {
  const method = config.method.toUpperCase();
  const account = AccountInfo.getAccountFromSys();
  const serviceToken = cookie.getCookie('serviceToken');
  const userIdObj = {};
  if (account.customerId) {
    userIdObj.customerId = account.customerId;
    userIdObj.accountId = account.customerId;
    userIdObj.emiAccountId = account.customerId;
    userIdObj.followUp = location.href;
    serviceToken && (userIdObj.serviceToken = serviceToken);

    if (config.data) {
      if (config.data instanceof FormData) {
        config.data.append('customerId', account.customerId);
        config.data.append('followUp', location.href);
      } else {
        config.data.customerId = account.customerId;
        config.data.accountId = config.data.accountId || account.customerId;
        userIdObj.accountId = config.data.accountId || account.customerId;
        config.data.emiAccountId = account.customerId;
      }
    }
  } else if (account.accountType) {
    const accountType = account.accountType == 4 ? 'core' : 'agent';
    userIdObj[accountType] = account.accountId;
    userIdObj.emiAccountId = account.emiAccountId || `${account.accountId}${account.accountType}`;
  }
  if (config.data && serviceToken) {
    if (config.data instanceof FormData) {
      config.data.append('serviceToken', serviceToken);
    } else {
      config.data.serviceToken = serviceToken;
    }
  }
  if (config.params) {
    config.params = Object.assign(userIdObj, config.params);
  } else {
    config.params = Object.assign(userIdObj);
  }
  if (method !== 'GET' && config.headers['Content-Type'] === 'application/json') {
    if (config.data.accountIds) {
      config.data.accountIds = [account.customerId];
    }
    config.data = JSON.stringify(config.data);
  } else if (method == 'POST' && config.headers.post['Content-Type'] === 'application/x-www-form-urlencoded' && !(config.data instanceof FormData)) {
    config.data = queryStringFix(config.data);
  }
  return config;
});

axios.interceptors.response.use(function (response) {
  let config = response.config;
  let res = response.data;
  // 未登录跳转
  if (res.code == 4000 || res.code == 9999 || (res.code == 239999 && res.message == '未登录')) {
    window.location.href = res.result;
  } else if (res.type === 'application/x-msdownload' || res.type === 'application/vnd.ms-excel' || res.type === 'text/xml') {
    return response;
  } else {
    if (!res.success && config.url.indexOf('dpa') === -1) { // dpa相关接口，是其它平台的接口。返回结构不带success字段
      if (config.customError) {
        return config.customError(res);
      } else if (config.errCb) {
        return response;
      } else if (!res.result || res.failMsg || res.message) {
        let msg = res.failMsg || res.message || '服务器错误';
        msg = msg.replace(/\r\n/g, '、');
        MessageBox.alert(msg);
        return Promise.reject(res);
      } else {
        return response;
      }
    } else if (config.url.indexOf('dpa') > -1 && res.code !== 0) {
      MessageBox.alert(res.message);
      return Promise.reject(res);
    }
  }
  return response;
});

export default axios;
